<template>
  <div
    v-if="
      permission('read', 'geolocation') &&
      item &&
      item.id &&
      item.latitude &&
      item.longitude
    "
    class="location-component"
  >
    <!-- Modal Moderno -->
    <b-modal
      :size="rest_home_id == 1 ? 'xl' : 'lg'"
      no-close-on-backdrop
      hide-footer
      :id="`modal_maps_${item.id}`"
      modal-class="modern-location-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-map-marker-alt mr-2"></i>
          Localização no Mapa
        </div>
      </template>

      <div class="modal-content-modern">
        <!-- Mapa para rest_home_id == 1 -->
        <div v-if="rest_home_id == 1" class="map-container">
          <GmapMap
            class="modern-map"
            :center="{
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
            }"
            :zoom="16"
            map-type-id="hybrid"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              streetViewControl: false,
              fullscreenControl: false,
              rotateControl: false,
            }"
          >
            <GmapMarker
              :position="{
                lat: parseFloat(item.latitude),
                lng: parseFloat(item.longitude),
              }"
              :clickable="true"
              :draggable="false"
              @click="infoWindowOpened = true"
            />

            <div v-if="created_at || user_name">
              <GmapInfoWindow
                :options="{ pixelOffset: { width: 0, height: -35 } }"
                :position="{
                  lat: parseFloat(item.latitude),
                  lng: parseFloat(item.longitude),
                }"
                :opened="infoWindowOpened"
                @closeclick="infoWindowOpened = false"
              >
                <div class="info-window-content">
                  <img v-if="logo" class="info-logo" :src="logo" alt="Logo" />

                  <div v-if="user_name" class="info-item">
                    <i class="fas fa-user mr-2"></i>
                    <span class="info-label">Cadastrado por:</span>
                    <span class="info-value">{{ user_name }}</span>
                  </div>

                  <div v-if="created_at" class="info-item">
                    <i class="fas fa-calendar mr-2"></i>
                    <span class="info-label">Data e hora:</span>
                    <span class="info-value">{{
                      formatDate(created_at, true)
                    }}</span>
                  </div>
                </div>
              </GmapInfoWindow>
            </div>
          </GmapMap>
        </div>

        <!-- Informações para outros rest_home_id -->
        <div v-if="rest_home_id != 1" class="location-info-container">
          <div class="location-info-card">
            <!-- Header do Card -->
            <div class="info-card-header">
              <h4 class="info-card-title">
                <i class="fas fa-info-circle mr-2"></i>
                Dados de Localização
              </h4>
            </div>

            <!-- Conteúdo do Card -->
            <div class="info-card-content">
              <div class="info-grid">
                <div v-if="user_name" class="info-section">
                  <div class="info-icon">
                    <i class="fas fa-user"></i>
                  </div>
                  <div class="info-details">
                    <span class="info-label">Cadastrado por</span>
                    <span class="info-value">{{ user_name }}</span>
                  </div>
                </div>

                <div v-if="created_at" class="info-section">
                  <div class="info-icon">
                    <i class="fas fa-calendar-alt"></i>
                  </div>
                  <div class="info-details">
                    <span class="info-label">Data e hora</span>
                    <span class="info-value">{{
                      formatDate(created_at, true)
                    }}</span>
                  </div>
                </div>

                <div class="info-section coordinates-section">
                  <div class="info-icon">
                    <i class="fas fa-crosshairs"></i>
                  </div>
                  <div class="info-details">
                    <span class="info-label">Coordenadas</span>
                    <div class="coordinates">
                      <div class="coordinate-item">
                        <span class="coordinate-label">Latitude:</span>
                        <span class="coordinate-value">{{
                          item.latitude
                        }}</span>
                      </div>
                      <div class="coordinate-item">
                        <span class="coordinate-label">Longitude:</span>
                        <span class="coordinate-value">{{
                          item.longitude
                        }}</span>
                      </div>

                      <div class="coordinate-item">
                        <span class="coordinate-label">Endereço de IP:</span>
                        <span class="coordinate-value">{{
                          item.ip_address
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Call to Action -->
              <div class="cta-section">
                <div class="cta-content">
                  <div class="cta-icon">
                    <i class="fas fa-external-link-alt"></i>
                  </div>
                  <div class="cta-text">
                    <h5 class="cta-title">Visualizar no Google Maps</h5>
                    <p class="cta-description">
                      Acesse o Google Maps para ver a localização exata no mapa
                    </p>
                  </div>
                </div>
                <a
                  :href="`https://www.google.com/maps?q=${item.latitude},${item.longitude}`"
                  target="_blank"
                  rel="noopener"
                  class="btn-maps-modern"
                >
                  <i class="fas fa-map mr-2"></i>
                  Abrir no Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Botão de Trigger Modernizado -->
    <div class="location-trigger">
      <v-btn
        :x-small="x_small"
        class="btn-location-modern"
        @click="handleModalMapa(item.id)"
      >
        <i class="fas fa-map-marker-alt mr-2"></i>
        <span class="btn-text">LOCALIZAÇÃO</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../lib/format";

import { userData } from "../../lib/functions";

import permission from "../../lib/permission";

export default {
  name: "LinkVerLocalizacaoRegistro",

  props: {
    item: Object,
    x_small: { type: Boolean, default: false },
  },

  data() {
    return {
      rest_home_id: null,
      logo: null,
      user_name: null,
      created_at: null,
      infoWindowOpened: true,
    };
  },

  watch: {
    item: {
      handler(item) {
        if (item) {
          if (item.checked_user && item.checked_user.user_name) {
            this.user_name = item.checked_user.user_name;
          }

          if (item.user_name) {
            this.user_name = item.user_name;
          }

          if (item.created_at) {
            this.created_at = item.created_at;
          }
        }

        let { logo } = userData();
        this.logo = logo;

        let { rest_home_id } = userData();
        this.rest_home_id = rest_home_id;
      },
      immediate: true,
    },
  },

  methods: {
    formatDate,
    permission,

    handleModalMapa(id) {
      this.$bvModal.show(`modal_maps_${id}`);
    },
  },
};
</script>

<style scoped>
/* Botão de Trigger */
.location-trigger {
  margin: 4px 0;
}

.btn-location-modern {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 8px 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-location-modern:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.4) !important;
}

.btn-location-modern i {
  color: white !important;
}

.btn-text {
  font-size: 12px !important;
  font-weight: 600 !important;
}

/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}

.modal-content-modern {
  padding: 0;
}

/* Mapa */
.map-container {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.modern-map {
  width: 100%;
  height: 500px;
  border-radius: 12px;
}

/* Info Window */
.info-window-content {
  padding: 12px;
  max-width: 250px;
}

.info-logo {
  width: 80px;
  height: auto;
  object-fit: contain;
  margin-bottom: 12px;
  display: block;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item i {
  color: #0f65b0;
  margin-right: 6px;
  width: 14px;
}

.info-label {
  font-weight: 600;
  color: #374151;
  margin-right: 4px;
}

.info-value {
  color: #1e293b;
}

/* Container de Informações */
.location-info-container {
  padding: 16px;
}

.location-info-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.info-card-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.info-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.info-card-title i {
  color: #0f65b0;
}

.info-card-content {
  padding: 24px;
}

/* Grid de Informações */
.info-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

.info-section {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.info-section:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.info-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
}

.info-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}

/* Seção de Coordenadas */
.coordinates-section .info-details {
  gap: 8px;
}

.coordinates {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.coordinate-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.coordinate-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}

.coordinate-value {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
}

/* Call to Action */
.cta-section {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #0284c7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.cta-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.cta-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  flex-shrink: 0;
}

.cta-text {
  flex: 1;
}

.cta-title {
  font-size: 16px;
  font-weight: 600;
  color: #0c4a6e;
  margin: 0 0 4px 0;
}

.cta-description {
  font-size: 14px;
  color: #075985;
  margin: 0;
}

.btn-maps-modern {
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 20px;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(2, 132, 199, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.btn-maps-modern:hover {
  background: linear-gradient(135deg, #0369a1 0%, #075985 100%);
  color: white;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(2, 132, 199, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content-modern {
    padding: 0;
  }

  .location-info-container {
    padding: 12px;
  }

  .info-card-header {
    padding: 16px;
  }

  .info-card-content {
    padding: 16px;
  }

  .info-section {
    padding: 12px;
  }

  .info-icon {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .cta-section {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .cta-content {
    flex-direction: column;
    gap: 12px;
  }

  .btn-maps-modern {
    width: 100%;
    justify-content: center;
  }

  .coordinate-item {
    flex-direction: column;
    gap: 4px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .btn-location-modern {
    padding: 6px 12px !important;
    font-size: 11px !important;
  }

  .btn-text {
    display: none;
  }

  .info-card-title {
    font-size: 16px;
  }

  .modern-map {
    height: 400px;
  }

  .cta-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .cta-title {
    font-size: 14px;
  }

  .cta-description {
    font-size: 13px;
  }
}

/* Override do Modal Bootstrap */
.modern-location-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
}

.modern-location-modal >>> .modal-body {
  padding: 0;
}

.modern-location-modal >>> .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}
</style>